import { Component, Input, OnInit } from '@angular/core';
import { AuthorizationPipe } from '../../common/pipes/authorization.pipe';
import { CustomerService } from '../services/customer.service';
import { DatePipe } from '@angular/common';
import { CacheService } from '../../shared/services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonService } from '../../shared/services/common.service';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { DistributorIdFormatPipe } from '../../common/pipes/distributor-id-format.pipe';
import { PaginationInstance } from 'ngx-pagination';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { OrderService } from '../services/order.service';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { CommonConstant } from '../../shared/constants/common.constants';
import * as moment from 'moment';
import { MemberTypeEnum } from '../enums/member-type.enum';


@Component({
    selector: 'activity-logs',
    templateUrl: '../templates/template1/views/member-activity-logs.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/profile-info.less'
    ],
    providers: [AuthorizationPipe, CustomerService, DatePipe, DistributorIdFormatPipe]
})


export class MemberActivityLogComponent implements OnInit {

    @Input() distributorInfo: DistributorInfo;
    @Input() inputid: string;
    @Input() fboid: string;
    @Input() memberType: string;

    memberID: Number;
    userId: number;
    userInfo: UserInfo;
    storeInfo: StoreConfig;
    pageNumber: number = 1;
    pageSize: number = 10;
    pageCount: number = 0;
    sortOrder: boolean = false;
    isDesc: Boolean= true;
    sortBy: string = "createdDate";
    memberActivityLogInfo: any = [];
    memberTypeEnum = MemberTypeEnum;

    public paginationInstance: PaginationInstance = {
        id: 'memberActivityLogs-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };

    constructor(private _commonService: CommonService
        , private _customerservice: CustomerService
        , private _cacheService: CacheService
        , private _orderService: OrderService,) {
    }

    ngOnInit(): void {
        this.memberID = this.distributorInfo && this.distributorInfo.memberId > 0 ? this.distributorInfo.memberId : null;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.userId = this._cacheService.get(CacheKey.UserId);
        if(this.memberID) {
            this.getStoreConfig();
        } else {
            this.getMemberInfo();
        }
     }

     /**
      * To get Member Information based on Fbo Id
      *
      */
     getMemberInfo(): void {
        this._customerservice.getMemberInformationFromTitan(this.fboid).subscribe(response => {
            if (response && response.isSuccess) {
                this.memberID = response.memberId;
                this.getStoreConfig();
            }
        });
     }

     /**
      *  get Store Details by Country code
      */
    getStoreConfig(): void {
        if (this.memberID) {
            this._orderService.getStoreInfo(CommonConstant.Default_Country).subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    this.getMemberActivityLogs();
                }
            });
        }
    }
    /**
   * get Member Activity logs
   */
    getMemberActivityLogs() {
        if (this.memberID) {
            const requestPayload = {
                'memberId': this.memberID,
                'pageSize': this.pageSize,
                'pageNumber': this.pageNumber,
                'sortOrder': this.sortOrder ? "ASC" : "DESC",
                'sortBy': this.sortBy
            };
            this._commonService.getMemberActivityLogs(requestPayload).subscribe(response => {
                if (response && response.totalRows && response.totalRows > 0) {
                    this.memberActivityLogInfo = [];
                    this.memberActivityLogInfo = response.activityLogs;
                    if (this.memberActivityLogInfo && this.memberActivityLogInfo.length > 0) {
                        this.memberActivityLogInfo.forEach(x => {
                            if (x && x.createdDate) {
                                x.monthDateFormat = moment.utc(x.createdDate)
                                .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY');
                                x.hoursDateFormat = moment.utc(x.createdDate)
                                .utcOffset(this.storeInfo.timeZoneOffset * 60).format('h:mm a');
                            }
                        });
                    }
                    this.pageCount = response.totalRows;
                } else {
                    this.pageCount = 0;
                    this.memberActivityLogInfo = [];
                }
            });
        }
    }

    /*
     * Sort member notes grid
    */
   sortMemberActivityLogs(sortBy: string) {
    this.isDesc = !this.isDesc;
        if (this.sortOrder === true) {
            this.sortOrder = false;
        } else {
            this.sortOrder = true;
        }
        this.sortBy = sortBy;
        this.getMemberActivityLogs();
    }

    /**
   * On Page change 
   * @param pageNumber 
   */
    pageChange(pageNumber: number) {

        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.sortOrder = false;
            this.getMemberActivityLogs();
        }
    }

  
 }



// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-activity-logs.component.ts